import React from 'react';

const AviationStack = ({ status, onClick }) => {
  return (
    <div className="aviation-stack-container">
      <div 
        className={`aviation-stack-box ${status.toLowerCase()}`} 
        onClick={onClick}
        role="button"
      >
        <p className="aviation-stack-box-title">Flight Data</p>
        <p className="aviation-stack-box-status">{status}</p>
      </div>
    </div>
  );
};

export default AviationStack; 